import React, { PureComponent } from 'react';
import { ScrollView } from '@dbk/ui-react-utils';
import { View } from '@dbk/ui-react-utils';
import { createContainer } from '@dbk-legacy/muster/react';
import Button from '@dbk/ui-buttons';
import { LoadingCircle } from '../../../../../../../src/components/common/loading';

class TransactionSecurityAdvice extends PureComponent {

  componentWillMount() {
    const { transaction } = this.props;
    //   posId:true,
    // transactionDate:true,
    // transactionNo:true,
    if(transaction){
      // this.props.getTransactionSecurityAdvices(transaction.posId, transaction.transactionDate, transaction.transactionNo);
      if (isNaN(transaction.transactionNo) || isNaN(transaction.posId) || transaction.transactionDate === '')
      {
        this.props.setSecurityAdviceList([]);
      }else{
        this.props.getTransactionSecurityAdvices(transaction.posId, transaction.transactionDate, transaction.transactionNo);
      }
    }

  }
  // componentWillUnmount(){
  //   const {
  //     reports: {
  //       transaction: {
  //         securityAdviceList,
  //       }
  //     },
  //   } = this.props;

  //   this.props.setSecurityAdviceList("");
  // }

  renderButton = () => {
    const {
      i18n: { messages },
      isPaymentAdviceAvailble,
      tertiary
    } = this.props
    // const temp = 1;
    /* advices number >0 */

    // if(temp > 0) {
    if (this.props.reports.transaction.securityAdviceList.length > 0) {
      return (
        <View testID="transaction-advices" style={{ textAlign: 'right', paddingTop: isPaymentAdviceAvailble ? 0 : 30 }}>
          <View className="seeAdvicesView" style={{float: 'right'}}>
            <Button size="large"
              tertiary={tertiary}
              onClick={this.renderAdvicesList}>
              {messages['app.chedelivery.reports.viewAdvice']}
            </Button>
          </View>
        </View>
      );
    }
    if(this.props.reports.showSpinner){
      return <LoadingCircle />
    }
    return <div />
  }

  renderAdvicesList = () => (
    this.props.changePage('/advices')
  )


  render() {
    return (
      <View>
        {this.renderButton()}
      </View>
    );
  }
}
TransactionSecurityAdvice.propTypes = {

};

export default createContainer({
  $queries: {
    // getAdviceDocumentId: { $call: 'adviceDocumentId' },
    $renderLoading: () => <LoadingCircle />,
    changePage: { $call: 'ui.history.push' },
    i18n: {
      messages: true,
    },
    getTransactionSecurityAdvices: {
      $call: 'reports.getTransactionSecurityAdvices'
    },
    reports: {
      transaction: {
        securityAdviceList: true,
      },
      showSpinner: true,
    },
    setSecurityAdviceList: {
      $set: 'reports.transaction.securityAdviceList'
    },
  }
})(TransactionSecurityAdvice)
